import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

import { MandatesApiService } from 'src/app/core/mandates-api/mandates-api.service';
import { ToastService } from 'src/app/service/toast.service';
import { BaseDialog } from 'src/app/shared/components/base-dialog/base-dialog';
import { StagingMandateStateService } from 'src/app/core/mandates-api/staging-mandate-state.service';

@Component({
  selector: 'mandates-mandate-actions',
  templateUrl: './mandate-actions.component.html',
  styleUrls: ['./mandate-actions.component.scss'],
})
export class MandateActionsComponent implements OnInit {

  public count: number = 0;

  constructor(
    private mandatesApiService: MandatesApiService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private matDialog: MatDialog,
    private stagingMandateStateService: StagingMandateStateService,
  ) {
  }

  ngOnInit(): void {
    this.requestCount();
  }

  requestCount(): void {
    this.mandatesApiService.getUnapprovedStagingMandatesCount().subscribe({
      next: (count) => {
        this.count = count;
      },
      error: () => {
        this.count = 0;
        this.toastService.openErrorToast(this.translateService.instant('TOAST.MANDATE-ACTIONS.FETCH-COUNT-FAILURE'));
      }
    });
  };

  refreshCount(): void {
    this.stagingMandateStateService.requestIndicators();
    this.requestCount();
  }

  requestApprove = (): void => {
    this.mandatesApiService.approveUnapprovedStagingMandates().subscribe({
      next: () => {
        this.toastService.openSuccessToast(this.translateService.instant('TOAST.MANDATE-ACTIONS.APPROVE-SUCCESS'));
        this.refreshCount();
      },
      error: () => {
        this.toastService.openErrorToast(this.translateService.instant('TOAST.MANDATE-ACTIONS.APPROVE-FAILURE'));
      },
    });
  };

  requestReject = (): void => {
    this.mandatesApiService.rejectUnapprovedStagingMandates().subscribe({
      next: () => {
        this.toastService.openInfoToast(this.translateService.instant('TOAST.MANDATE-ACTIONS.REJECT-SUCCESS'));
        this.refreshCount();
      },
      error: () => {
        this.toastService.openErrorToast(this.translateService.instant('TOAST.MANDATE-ACTIONS.REJECT-FAILURE'));
      },
    });
  };

  handleApprove(): void {
    this.requestApprove();
  };

  handleReject(): void {
    const dialogRef = this.matDialog.open(BaseDialog, {
      data: {
        title: 'DIALOG.DELETE.MANDATE-ACTIONS-REJECT-DESCRIPTION',
        cancelText: 'DIALOG.NO',
        confirmText: 'DIALOG.YES',
        confirmColor: 'accent',
      },
    });

    dialogRef.afterClosed()
      .pipe(filter(result => !!result))
      .subscribe(() => this.requestReject());
  };

}
